import { usePackageTrackPageInitializationHook } from "./usePackageTrackPageInitializationHook";

export default usePackageTrackPageInitializationHook;
